import { TFunction } from "i18next";

import { ReceiptSummary } from "../../../../../../../services/ReceiptProvider/types";
import { resolveReceiptCellDisplay } from "../../../../../../../utils/receiptDisplay.util";

export default function receiptStatusCellProcessing(
	receipt?: ReceiptSummary | null,
	t?: TFunction,
) {
	return resolveReceiptCellDisplay(receipt, t);
}
